import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { HeaderDebugPanelComponent } from '../../../shared/components/header-actions/header-debug-panel/header-debug-panel.component';
import { HeaderService } from '../../services/header/header.service';
import { NetworkConnectivityService } from '../../services/network-connectivity/network-connectivity.service';
import { ScreenService } from '../../services/responsive/screen.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgTemplateOutlet, HeaderDebugPanelComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  protected readonly headerService = inject(HeaderService);
  protected readonly screenService = inject(ScreenService);
  protected readonly network = inject(NetworkConnectivityService);
  protected readonly router = inject(Router);

  protected readonly isNotLoginPage = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => !this.router.url.includes('/login')),
      startWith(!this.router.url.includes('/login')),
    ),
    { initialValue: !this.router.url.includes('/login') },
  );
}
